import React from "react";
import { Plus, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

const today = () => { const d = new Date(); return new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, 10); };

export const RevisionHistory = ({ rows, onChange, currentRev, me }) => {
  const update = (i, k, v) => onChange(rows.map((r, j) => (j === i ? { ...r, [k]: v } : r)));
  const add = () => onChange([...rows, { rev: currentRev || "", revised_by: me || "", change: "", date: today() }]);
  const remove = (i) => onChange(rows.filter((_, j) => j !== i));
  return (
    <div data-testid="wd-history" className="space-y-2">
      <div className="flex items-center">
        <Label className="text-[11px] uppercase tracking-wider text-slate-500">Revision history</Label>
        <span className="text-[11px] text-slate-400 ml-2 hidden sm:inline">Fills the Revision Control and Amendment History tables</span>
        <Button type="button" size="sm" variant="outline" className="ml-auto h-7" onClick={add} data-testid="wd-history-add">
          <Plus className="h-3.5 w-3.5 mr-1" /> Add revision
        </Button>
      </div>
      {rows.length === 0 && <p className="text-xs text-slate-500">No revisions recorded yet.</p>}
      {rows.map((r, i) => (
        <div key={i} data-testid={`wd-history-row-${i}`} className="grid grid-cols-[70px_minmax(0,1fr)_32px] sm:grid-cols-[70px_150px_minmax(0,1fr)_140px_32px] gap-2 items-center">
          <Input className="h-8" value={r.rev} onChange={(e) => update(i, "rev", e.target.value)} placeholder="Rev" data-testid={`wd-history-rev-${i}`} />
          <Input className="h-8 hidden sm:block" value={r.revised_by} onChange={(e) => update(i, "revised_by", e.target.value)} placeholder="Revised by" data-testid={`wd-history-by-${i}`} />
          <Input className="h-8" value={r.change} onChange={(e) => update(i, "change", e.target.value)} placeholder="Change description" data-testid={`wd-history-change-${i}`} />
          <Input className="h-8 hidden sm:block" type="date" value={r.date} onChange={(e) => update(i, "date", e.target.value)} data-testid={`wd-history-date-${i}`} />
          <button type="button" onClick={() => remove(i)} className="h-8 w-8 rounded-lg text-slate-400 hover:text-rose-600 hover:bg-rose-50 flex items-center justify-center" aria-label="Remove revision" data-testid={`wd-history-remove-${i}`}>
            <X className="h-4 w-4" />
          </button>
        </div>
      ))}
    </div>
  );
};
